import React, { Fragment } from "react";
import { CashPackages } from './components'

export default () => {
    return (
      <Fragment>
        <CashPackages />
      </Fragment>
    );
  };